import React, {useEffect,useState,useRef} from 'react'
import client from '../client'

const PayMobile = ({params, submitRef, setLoading, setEnableSubmit}) => {
	const [tariff,setTariff] = useState(null);
	const [tariffs,setTariffs] = useState([]);
	const [resource,setResource] = useState(null);
	const tariffRef = useRef(null);
	const resourceRef = useRef(null);
	const {request,errorMessage} = client;

	const [phoneNumber, setPhoneNumber] = useState({
		part1: "260",
		part2: "",
		part3: "",
		part4: "",
	});

	const phoneNumberRef = useRef(null);

	const onSubmit = async () => {
		try {
			console.log(tariffRef)
			if(!params || !params.userId || !params.tariffable || !tariffRef.current || !resourceRef.current) {
				return {
					message: 'Invalid parameters'
				};
			}
			
			if (!phoneNumberRef.current.part1 || !phoneNumberRef.current.part2 || !phoneNumberRef.current.part3 || !phoneNumberRef.current.part4) {
				return { 
					message: "Invalid phone number"
				}
			}
			
			let number =
				phoneNumberRef.current.part1 +
				phoneNumberRef.current.part2 +
				phoneNumberRef.current.part3 +
				phoneNumberRef.current.part4;

			const response = await request('POST',`${resourceRef.current}/pay-mobile`,null,{
				userId:params.userId,
				tariffableReference:tariffRef.current.tariffableReference,
				criteriaValue:tariffRef.current.criteriaValue,
				durationUnit:tariffRef.current.durationUnit,
				duration:tariffRef.current.duration,
				phoneNumber:number,
				narration:params.tariffable.name
			})
			
			if (response && response.ref) {
				return {
					message: "Payment sent for processing",
					success: true,
				}
			} 

			return {
                message: errorMessage(response)
            };
		} catch (error) {
            return {
                message: errorMessage(error)
            };
        }
	} 

	const onPhoneNumber = (e) => {
		e.preventDefault();
		e.stopPropagation();
		let value = e.target.value;
		if (isNaN(value)) {
			return;
		}
		setPhoneNumber({ ...phoneNumber, [e.target.name]: value });
	};

	const onTariff = (e) => {
		const value = tariffs.find((trf) => {return `${trf.tariffableReference}${trf.criteriaValue}${trf.durationUnit}${trf.duration}` == e.target.value});
		if(value) {
			setTariff(value);
		} else {
			setTariff(null);
		}
	}

	const load = async () => {
		if(params && params.tariffable && params.rootValueReference) {
			await request('GET','tariffs/applicable',null,{
				tariffableReference:params.tariffable.ref.value,
				rootValueReference:params.rootValueReference
			})
			.then((response) => {
				if(response && response.length > 0) {
					setTariffs(response);
					setTariff(response[0]);
				} else {
					setTariffs([]);
				}
			})
			.catch((error) => {
				console.log(error)
				setTariffs([]);
			})

			await request("GET","resolver/derive-name",null,{
				ref:params.tariffable.ref.value
			})
			.then((res) => {
				setResource(res);
			})
			.catch((error) => {
				console.log(error);
			})
		}

		setLoading && setLoading(false);
	}

	useEffect(() => {
		tariffRef.current = tariff;
	}, [tariff]);

	useEffect(() => {
		resourceRef.current = resource;
	}, [resource]);

	useEffect(() => {
		phoneNumberRef.current = phoneNumber;
	}, [phoneNumber]);

	useEffect(() => {
		
		if (onSubmit) {
			submitRef.current = { submit: onSubmit };
			setEnableSubmit(true);
		} else {
			submitRef.current = null;
			setEnableSubmit(false);
		}

		load();

		return () => {
			submitRef.current = null;
		};
	},[])

	const inputStyle = (input) => {
		return `w-full h-[58px] px-4 text-[#767a80] font-nunitoSansRegular placeholder:text-[#767a80] bg-[rgb(247,247,247)] border ${input === "" ? "border-red-500" : "border-[rgb(200,200,200)]"} border-dashed rounded-lg outline-none focus:border-[rgb(0,175,240)]`
	}

	return (
		<div className='flex flex-col w-full'>
			<div className="flex flex-row justify-between w-full">
				<div className="w-24 h-24 p-2 overflow-hidden rounded-3xl">
					<img
						src="/images/airtel.png"
						alt="Airtel"
						className="object-contain object-center w-full h-full"
					/>
				</div>
				<div className="w-24 h-24 p-2 overflow-hidden rounded-3xl">
					<img
						src="/images/mtn.png"
						alt="Mtn"
						className="object-contain object-center w-full h-full"
					/>
				</div>
				<div className="w-24 h-24 p-2 overflow-hidden rounded-3xl">
					<img
						src="/images/zamtel.png"
						alt="Zamtel"
						className="object-contain object-center w-full h-full"
					/>
				</div>
			</div>
			<div className="flex flex-col w-full p-8 space-y-6 h-fit">
				<select
					name="tariff"  
					value={tariff? `${tariff.tariffableReference}${tariff.criteriaValue}${tariff.durationUnit}${tariff.duration}`:''}
					onChange={onTariff}
					className='w-full h-[58px] px-4 text-[#767a80] font-nunitoSansRegular placeholder:text-[#767a80] bg-[rgb(247,247,247)] border border-[rgb(200,200,200)] border-dashed rounded-lg outline-none focus:border-[rgb(0,175,240)]'
				> 
					{tariffs.length > 0 && 
						tariffs.map((trf,i) => 
						<option key={i} value={`${trf.tariffableReference}${trf.criteriaValue}${trf.durationUnit}${trf.duration}`}>
							{`${trf.duration}${trf.durationUnit.toLowerCase()}, K${trf.price}`}
						</option>)}
				</select>
				<div className="flex flex-row items-center w-full text-sm text-text">
					<label htmlFor="number" className="w-1/3 capitalize">
						Phone number
					</label>
					<div className="flex flex-row items-center justify-between w-2/3 space-x-1 overflow-hidden">
						<input
							type="text"
							inputMode="numeric"
							maxLength={3}
							name="part1"
							disabled={true}
							value={phoneNumber.part1}
							placeholder="000"
							onChange={onPhoneNumber}
							className={inputStyle(phoneNumber.part1)}
						/>
						<p className="">-</p>
						<input
							type="text"
							inputMode="numeric"
							maxLength={3}
							name="part2"
							value={phoneNumber.part2}
							placeholder="000"
							onChange={onPhoneNumber}
							className={inputStyle(phoneNumber.part2)}
						/>
						<p className="">-</p>
						<input
							type="text"
							inputMode="numeric"
							maxLength={3}
							name="part3"
							value={phoneNumber.part3}
							placeholder="000"
							onChange={onPhoneNumber}
							className={inputStyle(phoneNumber.part3)}
						/>
						<p className="">-</p>
						<input
							type="text"
							inputMode="numeric"
							maxLength={3}
							name="part4"
							value={phoneNumber.part4}
							placeholder="000"
							onChange={onPhoneNumber}
							className={inputStyle(phoneNumber.part4)}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}

export default PayMobile

